import { render } from "./DigitalSignageLayout.vue?vue&type=template&id=3634a7fa&scoped=true"
import script from "./DigitalSignageLayout.vue?vue&type=script&lang=js"
export * from "./DigitalSignageLayout.vue?vue&type=script&lang=js"

import "./DigitalSignageLayout.vue?vue&type=style&index=0&id=3634a7fa&lang=scss&scoped=true"

import exportComponent from "/home/controlcenter/sourcecode/dubiverse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3634a7fa"]])

export default __exports__